import API from "Classes/Api";
import {
  ApiGetCallParams,
  ApiPatchCallParams,
  ApiPostCallParams,
  ApiPutCallParams,
  ApiDeleteCallParams,
} from "Classes/ApiCallParams";

class AlertTypesService extends API {
  async getAlertTypesOverview({ clientId, filters }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/alerting/alert-types/overview`,
        headers: { ...API.getAuthHeaders() },
        body: {
          filters,
        },
        failureMessage: "Failed to get alert types",
      })
    );
    return result;
  }

  async getAlertDefinition({ clientId, alertTypeId, alertSubtypeId }) {
    const url = alertSubtypeId
      ? `/v2/clients/${clientId}/alerting/alert-types/${alertTypeId}/definition?alertSubtypeId=${alertSubtypeId}`
      : `/v2/clients/${clientId}/alerting/alert-types/${alertTypeId}/definition`;
    const result = await super.call(
      new ApiGetCallParams({
        action: url,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async updateAlertDefinition({ clientId, alertTypeId, alertSubtypeId, payload }) {
    const url = alertSubtypeId
      ? `/v2/clients/${clientId}/alerting/alert-types/${alertTypeId}/definition?alertSubtypeId=${alertSubtypeId}`
      : `/v2/clients/${clientId}/alerting/alert-types/${alertTypeId}/definition`;
    const result = await super.call(
      new ApiPatchCallParams({
        action: url,
        headers: { ...API.getAuthHeaders() },
        body: payload,
      })
    );
    return result;
  }

  async createCustomAlert({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/alerting/custom-alerts`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to create a custom alert",
      })
    );
    return result;
  }

  async updateCustomAlert({ clientId, alertTypeId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/alerting/custom-alerts/${alertTypeId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to update a custom alert",
      })
    );
    return result;
  }

  async deleteCustomAlert({ clientId, alertTypeId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `/v2/clients/${clientId}/alerting/custom-alerts/${alertTypeId}`,
        headers: { ...API.getAuthHeaders() },
        failureMessage: "Failed to delete a custom alert",
      })
    );
    return result;
  }

  async triggerEvaluation({ clientId, alertTypeId }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/alerting/custom-alerts/${alertTypeId}:triggerEvaluation`,
        headers: { ...API.getAuthHeaders() },
        failureMessage: "Failed to evaluate the custom alert.",
        successMessage: "Custom alert has been queued for evaluation.",
      })
    );
    return result;
  }
}

const instance = new AlertTypesService();
export default instance;
